export const FormGroupRow = {
  transclude: {
    left: '?formGroupLeft',
    right: '?formGroupRight',
  },

  template: `
    <div class="form-group">
      <div class="form-row">
        <div class="col-sm-4">
          <div class="col-form-label pb-0" ng-transclude="left"></div>
        </div>
        <div class="col-sm-8" ng-transclude="right"></div>
      </div>
    </div>`,
};



// WEBPACK FOOTER //
// ./src/components/FormElements/FormGroupRow.js